export const FallbackAuthErrorMessage = {
  SomethingWentWrong: 'Something went wrong',
};
